/**
 * @generated SignedSource<<ef2d5a4ae80c5f1b331023c6413b3681>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type WorkSuggestionsEnvironmentType = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type failedDeployment_periscope_FailedDeploymentTask$data = {
  readonly __typename: "WorkSuggestionsDeploymentTask";
  readonly environmentType: WorkSuggestionsEnvironmentType;
  readonly id: string;
  readonly issueKey: string;
  readonly lastUpdated: string;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "failedDeployment_periscope_FailedDeploymentTask";
};
export type failedDeployment_periscope_FailedDeploymentTask$key = {
  readonly " $data"?: failedDeployment_periscope_FailedDeploymentTask$data;
  readonly " $fragmentSpreads": FragmentRefs<"failedDeployment_periscope_FailedDeploymentTask">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "failedDeployment_periscope_FailedDeploymentTask",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "environmentType"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "issueKey"
    },
    {
      "kind": "ScalarField",
      "name": "lastUpdated"
    }
  ],
  "type": "WorkSuggestionsDeploymentTask"
};

(node as any).hash = "13c01adb9f14da0cafd5b24035187564";

export default node;
